import { Check } from "@mui/icons-material";
import {
  IconButton,
  IconButtonProps,
  InputAdornment,
  useTheme,
} from "@mui/material";

export const VerifyIconButton: React.FC<IconButtonProps> = ({
  sx,
  ...props
}) => {
  const theme = useTheme();

  return (
    <InputAdornment position="end">
      <IconButton
        edge="end"
        size="small"
        sx={{
          width: 32,
          height: 32,
          borderRadius: "6px",
          color: theme.palette.primary.main,
          ml: 1,
          backgroundColor: theme.palette.primary.main,
          "&:hover": {
            backgroundColor: theme.palette.primary.dark,
          },
          "&:disabled": {
            backgroundColor: theme.colors.primary[1],
          },
          ...sx,
        }}
        {...props}
      >
        <Check sx={{ color: theme.colors.defaultBackground }} />
      </IconButton>
    </InputAdornment>
  );
};
